import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Share } from '../../../../../utils/Share'
import { useTw } from '../../../../../utils/Styles'
import { localizeString } from '../../../../../utils'
import { Avatars } from '../../../../../utils/Avatars'
import { useProfile } from '../../../../../utils/Profile'
import {
  useKnowledgeBaseQuery,
  KnowledgeBaseQuery,
} from './KnowledgeBase.generated'

type Props = {
  pinned: KnowledgeBaseQuery['Profile']['knowledgeBase']['pinned']
}

type ArticleProps = {
  article: Props['pinned'][0]
}

function KnowledgeBaseArticle({ article }: ArticleProps) {
  const tw = useTw()
  const navigate = useNavigate()
  const { account } = useProfile()
  const [t] = useTranslation('common')
  const users = [
    article.createdBy,
    article.createdBy._id === article.publishedBy._id
      ? undefined
      : article.publishedBy,
  ]

  const shareBaseUrl = account?.clientPortal?.customDomain
    ? `https://${account?.clientPortal?.customDomain}`
    : `https://${account.slug}.firesquad.io`

  return (
    <div
      className={tw`flex flex-col border-t-2 border-background bg-white p-4 shadow-md rounded`}
    >
      <a
        className={tw`text-foreground cursor-pointer`}
        onClick={() =>
          navigate(`/kb/${article.categoryId}/${article.articleId}`)
        }
      >
        {localizeString(article.title)}
      </a>
      <p
        title={localizeString(article.subtitle)}
        className={tw`pt-2 text-gray-600 leading-5 line-clamp-3`}
      >
        {localizeString(article.subtitle)}
      </p>
      <div className={tw`flex justify-between items-center pt-4`}>
        <div className={tw`flex flex-row select-none`}>
          <Avatars users={users} />
          <div className={tw`ml-2`}>
            <p className={tw`text-sm text-neutral-400 font-bold`}>
              {t('home.kb_article.written_by')}
            </p>
            <p className={tw`text-sm text-neutral-350`}>
              {users
                .filter((_) => _?._id)
                .map((_) => _.name)
                .join(' & ')}
            </p>
          </div>
        </div>
        {account?.clientPortal?.knowledgeBaseEnabled ? (
          <Share
            title={localizeString(article.title)}
            text={localizeString(article.subtitle)}
            url={`${shareBaseUrl}/category/${article.categoryId}/article/${article.articleId}`}
          />
        ) : null}
      </div>
    </div>
  )
}

export function KnowledgeBasePinned() {
  const { data } = useKnowledgeBaseQuery()

  return (
    <>
      {data?.Profile?.knowledgeBase?.pinned.map((article) => (
        <KnowledgeBaseArticle key={article._id} article={article} />
      ))}
    </>
  )
}
